export default __webpack_public_path__ + "static/media/Shopping.369c9ea7.svg";